import Vue from "vue";
import Router from "vue-router";

import LoginController from "@/components/screens/LoginController";

import PPEFormDisabled from "@/components/screens/PPEFormDisabled";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "is-active",
  routes: [
    {
      path: "/",
      name: "LoginController",
      component: LoginController,
    },
    {
      path: "/m/:vars",
      name: "LoginController",
      component: LoginController,
    },
    {
      path: "/ppeform",
      name: "PPEForm",
      component: PPEFormDisabled,
    },
    {
      path: "/sewist",
      name: "LoginController",
      component: LoginController,
      props: {
        sewistOverride: true,
      },
    },
  ],
});
